import BaseService from '../baseServices';
import REST from '../../configs/rest';
import { paramsFilter } from '../../utils/requests';

function postChargeApprovalSignature({ body }) {
  return BaseService.post(REST.CHARGE_APPROVAL_SIGNATURE, body);
}

function putChargeApprovalSignature({ body, id }) {
  return BaseService.put(REST.CHARGE_APPROVAL_SIGNATURE_ID(id), body);
}

function getChargeApprovalSignature(params) {
  return BaseService.get(REST.CHARGE_APPROVAL_SIGNATURE, {
    params: paramsFilter({ params }),
  });
}

function deleteChargeApprovalSignature({ id }) {
  return BaseService.delete(REST.CHARGE_APPROVAL_SIGNATURE_ID(id));
}

export default {
  postChargeApprovalSignature,
  putChargeApprovalSignature,
  getChargeApprovalSignature,
  deleteChargeApprovalSignature,
};
